<template>
  <div class="w-100 pa-2">
    <v-card 
      color="transparent"
      class="glass-card w-100 mt-1 pa-4 d-flex flex-row flex-wrap justify-center align-center"
      elevation="0"
    >
      <a
        v-for="(item, i) in displayedMedias"
        :key="i"
        class="social-icon-btn elevation-2 d-flex align-center justify-center mx-2 my-2 text-decoration-none"
        :style="{
          background: value?.socialMediaIcons?.sectionColor?.backGround || 'rgba(255,255,255,0.15)',
        }"
        @click.prevent="$emit('go-to-url', item.url, item.pattern)"
        :title="item.label"
      >
        <svg-base :view-box="getViewBox(item.name)" style="display: block; margin: auto;">
            <component :is="item.svg" class="mt-0" />
        </svg-base>

        <!-- <svg-base :view-box="50" style="width: 26px; height: 26px;">
          <component :is="item.svg" />
        </svg-base> -->
      </a>
    </v-card>

    <div v-if="medias.length > initialLimit" class="toggle-container mt-4">
      <div class="divider-line"></div>
      <div 
        class="toggle-btn glass-card text-caption font-weight-bold mx-3"
        @click="isExpanded = !isExpanded"
      >
        {{ isExpanded ? 'نمایش کمتر' : 'نمایش بیشتر' }}
        <v-icon small class="mr-1" color="white">
          {{ isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
        </v-icon>
      </div>
      <div class="divider-line"></div>
    </div>
  </div>
</template>

<script>
import SvgBase from "@/view/content/svgLoader/svgBase";

const viewBoxConfig = {
  // شبکه‌های اجتماعی ایرانی
  aparat: 40,
  gap: 40,

  // شبکه‌های اجتماعی خارجی
  linkedin_company: '-10 -10 60 60',
  github: 32,
  threads: 42,
  skype: 40,
  youtube: 40,
  wechat: 40,
  viber: 40,

  // سایت‌های آگهی و فروشگاهی
  divar: '0 0 40 24.33',
  sheypoor: 40,
  digikala: '0.00 0.00 1080.00 1080.00',
  basalam: '0 0 128 208',
  snappshop: '0 0 69 40',    
  technolife: '0 0 112 42',
  torob: '0.00 0.00 130.00 130.00',        
  emalls: '0.00 0.00 300.00 78.00',

  // استورها
  cafebazaar: '0.00 0.00 303.00 132.00',
  googleplay: '0 -4.447 361.403 408.86699999999996',
  samsung: '0 0 230 230',
  apple: '0 0 512 512',
}

export default {
  name: "SocialWarp",
  components: { SvgBase },
  props: {
    medias: { type: Array, required: true },
    value: { type: Object, required: true },
    hexToRgba: { type: Function, required: false },
    getSocialColor: { type: Function, required: false }
  },
  data() {
    return {
      isExpanded: false,
      initialLimit: 10, 
    };
  },
    methods:{
      getViewBox(name) {
      return viewBoxConfig[name] || '0 0 50 50';
    },

  },
  computed: {
    displayedMedias() {
      if (this.isExpanded) {
        return this.medias;
      }
      return this.medias.slice(0, this.initialLimit);
    }
  }
};
</script>

<style scoped>
.glass-card {
  background: rgba(255, 255, 255, 0.1) !important;
  backdrop-filter: blur(10px) !important;
  -webkit-backdrop-filter: blur(10px) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  border-radius: 16px !important;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1) !important;
}

.social-icon-btn {
  width: 50px !important;
  height: 50px !important;
  border-radius: 50% !important;
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
}

.social-icon-btn:hover {
  transform: translateY(-4px) scale(1.08);
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.3) !important;
  background: rgba(255, 255, 255, 0.3) !important;
}

::v-deep svg {
  fill: #ffffff;
}

/* استایل‌های بخش نمایش بیشتر */
.toggle-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.divider-line {
  flex-grow: 1;
  height: 1px;
  background: rgba(255, 255, 255, 0.2);
}

.toggle-btn {
  display: flex;
  align-items: center;
  padding: 6px 16px;
  border-radius: 20px !important;
  cursor: pointer;
  user-select: none;
  transition: all 0.3s ease;
  color: white;
}

.toggle-btn:active {
  transform: scale(0.95);
}
</style>
